import React from 'react';
import { renderPage } from '../common/renderPage';
import { SplitOrderApp } from '../pageComponents/split-order/split-order';

renderPage(<SplitOrderApp />, "#SplitOrderPage");